import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updadteHeightPforte, updateWidthPforte, updateStepsPforte} from '../../../../store/actions/pforten';

import TextField from '@material-ui/core/TextField';


const Step_2 = (props) => {
   const [height, updateHeight] = useState(0);
   const [width, update_Width] = useState(0);


   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      const {height, width} = props.data.dimensions[0];

      updateHeight(height);
      update_Width(width);

      //update steps
      props.updateSteps(1);
      if(height && width) props.updateSteps(2);

      //Weiter-Button aktivieren
      if((height && width) || props.data.allVisitedSteps) {
         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue()
      }
   }

   const updadteHeight = ev => {
      props.updadteHeight(ev.target.value);
      updateItems();
   }

   const updateWidth = ev => {
      props.updateWidth(ev.target.value);
      updateItems();
   }


       return (
           <div className="step_wrapper">
             <h2 className="step_header">Wie sind Ihre Maße für die Pforte?</h2>
              <div className="step_icon_wrapper">
                 <div className="inner_masseMenge_wrapper">
                  <div className="textfield-wrapper">
                        <TextField
                           className="textfield-masse-quantity"
                           label="Breite (in cm)"
                           type="number"
                           rowsMax={1}
                           value={width}
                           name="width"
                           onChange={updateWidth}
                        >
                     </TextField>
                     <TextField
                           className="textfield-masse-quantity"
                           label="Höhe (in cm)"
                           type="number"
                           rowsMax={1}
                           value={height}
                           name="height"
                           onChange={updadteHeight}
                        >
                     </TextField>
                  </div>
                </div>
            </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
      data: state.pfortenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updadteHeight: ev => dispatch(updadteHeightPforte(ev)),
      updateWidth: ev => dispatch(updateWidthPforte(ev)),
      updateSteps: ev => dispatch(updateStepsPforte(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_2);
